class LoadMorePosts {
	constructor() {
		this.$ = jQuery;

		this.LoadMorePostsButton  = this.$( '#load-more-posts' );
		this.LoadMoreSearchButton = this.$( '#load-more-search-posts' );

		this.listeners();
	}

	listeners() {
		if ( this.LoadMorePostsButton ) {
			this.$( this.LoadMorePostsButton ).click(
				{
					self: this,
					container: this.$( '.posts-listing > .row' ),
					action: 'get_posts'
				},
				this.loadMore
			);
		}

		if ( this.LoadMoreSearchButton ) {
			this.$( this.LoadMoreSearchButton ).click(
				{
					self: this,
					container: this.$( '.search-page .result' ),
					action: 'get_search_posts'
				},
				this.loadMore
			);
		}
	}

	loadMore( event ) {
		let self = event.data.self;
		let container = event.data.container;
		let action = event.data.action;

		self.$( this ).addClass( 'loading' );
		self.$( '.sk-bounce' ).addClass( 'loading' );

		let postData = {
			action: action,
			paged: ajax.current_page,
			query: ajax.query
		};

		self.$
			.ajax({
				url: ajax.url,
				method: 'post',
				data: postData,
				dataType: 'json'
			})
			.done( response => {

				ajax.current_page++;

				self.$( this ).removeClass( 'loading' );
				self.$( '.sk-bounce' ).removeClass( 'loading' );

				self.$.each( response.html, function( key, data ) {
					console.log( data );

					self.$( data )
						.hide()
						.appendTo( container )
						.fadeIn();
				});

				if ( ajax.current_page == ajax.max_page ) {
					self.$( this ).hide();
				}
			});
	}
}

export default LoadMorePosts;


